export const GET_ALL_TIMELINE = "GET_ALL_TIMELINE";
export const UPDATE_POST = "UPDATE_POST";
export const PUBLISH_POST = "PUBLISH_POST";
export const CREATE_POST = "CREATE_POST";
export const DELETE_POST = "DELETE_POST";
export const PAGE_INCREAMENT = "PAGE_INCREAMENT";
export const CLEAR_ALL = "CLEAR_ALL";
export const GET_SINGLE_POST = "GET_SINGLE_POST";
export const CLEAR_SINGLE_POST = "CLEAR_SINGLE_POST";
export const SET_LOADER = "SET_LOADER";
export const GET_ALL_LIST = "GET_ALL_LIST";
export const UPDATE_LIST = "UPDATE_LIST";
export const CREATE_LIST = "CREATE_LIST";
export const SET_LIST_LOADER = "SET_LIST_LOADER";
export const LIST_PAGE_INCREAMENT = "LIST_PAGE_INCREAMENT";
export const CLEAR_ALL_LIST = "CLEAR_ALL_LIST";
export const GET_ALL_POLL_LIST = "GET_ALL_POLL_LIST";
export const UPDATE_POLL = "UPDATE_POLL";
export const CREATE_POLL = "CREATE_POLL";
export const CLEAR_ALL_POLL = "CLEAR_ALL_POLL";
export const SET_POLL_LOADER = "SET_POLL_LOADER";
export const POLL_PAGE_INCREAMENT = "POLL_PAGE_INCREAMENT";
export const GET_ALL_TEAMS = "GET_ALL_TEAMS";
export const UPDATE_TEAM = "UPDATE_TEAM";
export const CREATE_TEAM = "CREATE_TEAM";
export const DELETE_TEAM = "DELETE_TEAM";
export const CLEAR_ALL_TEAMS = "CLEAR_ALL_TEAMS";
export const DELETE_POLL = "DELETE_POLL";
export const GET_ALL_WALL_OF_FAME = "GET_ALL_WALL_OF_FAME";
export const UPDATE_WALL_OF_FAME = "UPDATE_WALL_OF_FAME";
export const CREATE_WALL_OF_FAME = "CREATE_WALL_OF_FAME";
export const DELETE_WALL_OF_FAME = "DELETE_WALL_OF_FAME";
export const SET_WALL_OF_FAME_LOADER = "SET_WALL_OF_FAME_LOADER";
export const PAGE_INCREAMENT_WALL_OF_FAME = "PAGE_INCREAMENT_WALL_OF_FAME";
export const CLEAR_ALL_WALL_OF_FAME = "CLEAR_ALL_WALL_OF_FAME";
export const GET_TIMELINE_INTRO_VIDEOS = "GET_TIMELINE_INTRO_VIDEOS";
export const GET_TIMELINE_OUTRO_VIDEOS = "GET_TIMELINE_OUTRO_VIDEOS";
export const GET_TIMELINE_MESSAGE_TEMPLATES = "GET_TIMELINE_MESSAGE_TEMPLATES";
export const GET_LATEST_RECOGNITION = "GET_LATEST_RECOGNITION";
export const CREATE_POST_END = "CREATE_POST_END";
export const UPDATE_SINGLE_POST = "UPDATE_SINGLE_POST";
export const SAVE_SEARCH_TNAME = "SAVE_SEARCH_TNAME";
export const SAVE_SORT = "SAVE_SORT";
export const CLEAR_SEARCH_TNAME = "CLEAR_SEARCH_TNAME";
export const GET_AVATARS = "GET_AVATARS";
export const GET_SOUNDS = "GET_SOUNDS";
export const GET_COMPANY_DATA = "GET_COMPANY_DATA";
export const CLEAR_COMPANY_DATA = "CLEAR_COMPANY_DATA";
export const SET_COMPANY_LOADER = "SET_COMPANY_LOADER";
export const COMPANY_PAGE_INCREAMENT = "COMPANY_PAGE_INCREAMENT";
export const UPDATE_COMPANY_POST = "UPDATE_COMPANY_POST";
export const SET_TOTAL_COMPANY = "SET_TOTAL_COMPANY";

// Course Action Types
export const GET_ALL_COURSES = "GET_ALL_COURSES";
export const GET_COURSE = "GET_COURSE";
export const CREATE_COURSE = "CREATE_COURSE";
export const UPDATE_COURSE = "UPDATE_COURSE";
export const DELETE_COURSE = "DELETE_COURSE";
export const SET_COURSE_LOADER = "SET_COURSE_LOADER";
export const COURSE_PAGE_INCREAMENT = "COURSE_PAGE_INCREAMENT";
export const CLEAR_ALL_COURSES = "CLEAR_ALL_COURSES";

// My Courses Action Types
export const GET_MY_COURSES = "GET_MY_COURSES";
export const SET_MY_COURSES_LOADER = "SET_MY_COURSES_LOADER";
export const MY_COURSES_PAGE_INCREMENT = "MY_COURSES_PAGE_INCREMENT";
export const CLEAR_MY_COURSES = "CLEAR_MY_COURSES";